import React from "react";
import { offer } from "../data/offer";
export function PriceList() {
  return <div className="rounded-2xl bg-paper p-5 ring-1 ring-line" data-id="element-201" data-mp="1ds8innc7mnss">
      <p className="text-sm font-bold text-ink" data-id="element-202" data-mp="1dsrzf0q4j658">Precio según tu país</p>
      <dl className="mt-2 divide-y divide-line" data-id="element-203" data-mp="1iqtkfr741fjc">
        {offer.prices.map((p, i) => <div key={p.country} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-3" data-id="element-204" data-mp="1nrpms0btctmn" data-mpi={i}>
            <dt className="text-sm font-semibold text-muted" data-id="element-205" data-mp="1sozmq9wtwnoq">{p.country}</dt>
            <dd className={`whitespace-nowrap font-display font-semibold leading-none text-ink ${i === 0 ? "text-3xl sm:text-4xl" : "text-2xl"}`} data-id="element-206" data-mp="1wqkuxhyf4dsl">
              {p.amount}
            </dd>
          </div>)}
      </dl>
    </div>;
}